import { ConfigPath, QuickSwitchItem } from '../insight/config.insight.model';
import {
    CriteriaIdType,
    PerformanceDataViewType,
    PerformanceDataViewTypeArgsMap,
} from '../performance-data/metric.pd.model';

const pt1 =
    PerformanceDataViewTypeArgsMap[PerformanceDataViewType.TEAM_SUPER_GROUP];
const pt2 =
    PerformanceDataViewTypeArgsMap[PerformanceDataViewType.USER_SUPER_GROUP];

export const TEAM_SUPER_GROUP_PATH: ConfigPath = {
    pathIdentifier: null,
    name: null,
    shortName: null,
    initials: null,
    displayOrder: null,
    levels: [
        {
            identifier: 'aaa',
            performanceDataViewType: PerformanceDataViewType.TEAM_SUPER_GROUP,
            displayNameCriteriaIdType: pt1.secondary,
            outputCriteriaIdType: pt1.primary,
            outputCriteriaIdTypes: [pt1.primary],
            inputCriteriaIdTypes: [
                CriteriaIdType.SUPER_GROUP_ID,
                CriteriaIdType.TEAM_ID,
                CriteriaIdType.TEAM_ROLE_ID,
            ],
            inputCriteriaIdTypeArgs: null,
            displayOrder: 1,
            allowNewTab: null,
            newTabViewType: null,
            newTabPathType: null,
            previousLevelsRecurse: null,
            name: null,
            shortName: null,
            initials: null,
            levels: [
                {
                    identifier: 'bbb',
                    performanceDataViewType:
                        PerformanceDataViewType.USER_SUPER_GROUP,
                    displayNameCriteriaIdType: pt2.primary,
                    outputCriteriaIdType: pt2.primary,
                    outputCriteriaIdTypes: [pt2.primary],
                    inputCriteriaIdTypes: [
                        CriteriaIdType.SUPER_GROUP_ID,
                        CriteriaIdType.TEAM_ID,
                        CriteriaIdType.TEAM_ROLE_ID,
                    ],
                    inputCriteriaIdTypeArgs: null,
                    displayOrder: 1,
                    allowNewTab: true,
                    newTabViewType: null,
                    newTabPathType: null,
                    previousLevelsRecurse: null,
                    name: null,
                    shortName: null,
                    initials: null,
                    levels: null,
                },
            ],
        },
    ],
};

export interface SuperGroupExtra {
    teamSuperGroup: boolean;
}

export interface SuperGroupHumanInsightSelectionChangeEvent {
    selected: QuickSwitchItem<SuperGroupExtra>;
}
